import { render, staticRenderFns } from "./MaterialManagement.vue?vue&type=template&id=2a513f86"
import script from "./MaterialManagement.vue?vue&type=script&lang=js"
export * from "./MaterialManagement.vue?vue&type=script&lang=js"
import style0 from "./MaterialManagement.vue?vue&type=style&index=0&id=2a513f86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports